export class GenericGroup {
    genGrpId:number;
}
